<script>
import BarList from '../components/bar-list'
import ItemForm from './item-form'
import AnexosForm from '../components/anexos-form'
import { getText, formatDate } from '../shared/utils'
import { SysVars } from '../main';
import { apiORDS, apiORDSpost, apiDownloadPDF, apiEmailPDF } from '../shared/api-functions'

export default {
  data() {
    return {
      showForm: false, //exibe a tela de manutencao
      showFormControlePedidos: false, //form de cadastro para controle de pedidos
      crud: '', //indica o modo de edicao: incluir, alterar, visualizar, etc
      coditem: '',
      descricao: '',
      searchString: '',
      metadata: this.$store.getters.getEntities.metadata,
      filter: '',
      showAnexosForm: false,
      offset: false,
      gerarEtiqueta: false,
      modalEtiqueta: false,
      marcarTodosProdutos: false,
      produtosMarcados: [],
      filial: null,
      parametros: null,
      listaEtiquetas: [],
      etiquetaSelecionada: 1,
      grade: null,
      hasItemChecked: false
    }
  },

  computed: {
    possuiPermissao: function () {
      return SysVars.appNFe || (SysVars.usuarioAdministrador && SysVars.appForcaVendas)
    },

    moreActionsBarList: function () {
      if (!this.possuiPermissao)
        return null
      else
        return [
          { action: 0, label: 'Importar Produtos' },
          { action: 1, label: 'Importar Estoque' },
          { action: 2, label: 'Gerar Etiqueta' },
        ]
    },

    nextPage: function () {
      return this.$store.getters.getNextPage
    },

    itemList: function () {
      return this.$store.getters.getItemList
    },

    produtosSelecionados() {
      return (this.itemList || []).filter(item => item.isChecked).length
    },

    possuiPermissao: function () {
      if (SysVars.usaIntegracao) {
        return false;
      }
      return SysVars.appNFe || SysVars.appERP || SysVars.appLoja || (SysVars.usuarioAdministrador && SysVars.appForcaVendas)
    },

    filialList: function () {
      return this.$store.getters.getFilialList
    },
    item: function () {
      return this.$store.getters.getItem[0]
    },
    showGuia: function () {
      return SysVars.guia
    }


  },

  watch: {
    itemList: {
      handler: function (newValue) {
        const hasItemChecked = newValue.find(item => item.isChecked);
        if (hasItemChecked) {
          this.hasItemChecked = true
        } else {
          this.hasItemChecked = false
        }

      },
      deep: true,
      immediatle: true
    },
    marcarTodosProdutos() {
      if (this.marcarTodosProdutos) {
        this.hasItemChecked = true
        this.itemList.map(item => {
          item.isChecked = true

        })
      } else {
        this.hasItemChecked = false
        this.itemList.map(item => {
          item.isChecked = false

        })
      }
    },
  },

  methods: {
    scroll() {
      window.onscroll = () => {
        if (this.showForm || this.showFormControlePedidos || this.offset || this.nextPage == 0)
          return
        let bottomOfWindow = Math.max(window.pageYOffset, document.documentElement.scrollTop, document.body.scrollTop) + window.innerHeight >= (document.documentElement.offsetHeight - 2)

        if (bottomOfWindow) {
          this.offset = true
          this.loadData()
        }
        SysVars.scrollPosition = document.documentElement.scrollTop
      }
    },

    handleEdit(cod, view) {
      //abre a tela de edicao

      if (view)
        this.crud = SysVars.crudView
      else
        this.crud = SysVars.crudU

      this.coditem = cod
      if (SysVars.controlePedidos)
        this.showFormControlePedidos = true
      else
        this.showForm = true
    },

    handleNew() {
      //inclusao de registro
      if (!this.possuiPermissao) {
        this.$erpToastError('Usuário sem permissão.')
        return
      }
      this.crud = SysVars.crudI
      this.coditem = ''
      if (SysVars.controlePedidos)
        this.showFormControlePedidos = true
      else
        this.showForm = true
    },

    handleAnexosForm(coditem, descricao) {
      this.coditem = coditem
      this.descricao = descricao
      this.showAnexosForm = true
    },

    handleArchive(coditem) {
      const state = {
        filter: this.filter,
        searchString: this.searchString
      };
      sessionStorage.setItem('fvProdutosState', JSON.stringify(state));
      this.$router.push({ path: '/consultas/estoque-produto', query: { coditem: coditem } });
    },

    closeForm() {
      this.showForm = false
      this.showAnexosForm = false
      this.showFormControlePedidos = false
      this.loadData()
    },

    handleAction(act) {
      if (act == 0) {
        if (!this.possuiPermissao)
          this.$erpToastError('Usuário sem permissão.')
        else
          //importação de cadastro de produtos
          this.$router.push('/importa/produtos')
      }

      if (act == 1) {
        //importação de cadastro de produtos
        this.$router.push('/importa/estoque')
      }

      if (act == 2) {
        this.gerarEtiqueta = true
      }
    },

    async showModalImprimirEtiqueta() {
      console.log(this.hasItemChecked, this.itemList)
      if (!this.hasItemChecked) {
        this.$erpToastError('É necessário selecionar um produto');
        return;
      }
      const codfil = this.filialList[0].codfil
      await this.$store.dispatch('loadFilial', { id: codfil })

      if (this.$store.getters.getFilial) {
        this.filial = { ...this.$store.getters.getFilial }
        if (this.filial.parametros) {
          this.parametros = JSON.parse(this.filial.parametros)
        } else {
          this.parametros = {}
        }
      }

      const produtosMarcados = this.itemList.filter((item) => {
        return item.isChecked == true
      })

      var printProdutos = []

      produtosMarcados.map(async produto => {
        printProdutos.push({ codigo: produto.codigo, coditem: produto.coditem, descricao: produto.descricao })

        await this.$store.dispatch('loadItem', { id: produto.coditem })
        if (this.item) {
          const gradeItem = JSON.parse(this.item.grade)
          if (gradeItem.linhas.length > 0) {
            gradeItem.linhas.map(linha => {
              linha.colunas.map(coluna => {
                if (coluna.ativo)
                  printProdutos.push({
                    codigo: produto.codigo,
                    coditem: produto.coditem,
                    descricao: produto.descricao + ' ' + linha.descricao + ' ' + coluna.descricao,
                    coditemgrade: coluna.coditemgrade
                  })
              })
            })
          }
        }
      })

      this.produtosMarcados = printProdutos

      const etiquetas = this.parametros.etiquetas;

      this.listaEtiquetas = [];

      etiquetas.map((etiqueta, i) => {
        this.listaEtiquetas.push({
          id: i += 1,
          text: etiqueta.descricao
        })
      })

      this.modalEtiqueta = true
    },

    closeModalImprimirEtiqueta() {
      this.modalEtiqueta = false
    },

    deleteItemImprimirEtiqueta(produto) {
      const indiceProduto = this.produtosMarcados.indexOf(produto)
      this.produtosMarcados.splice(indiceProduto, 1)
    },

    search(value) {
      this.searchString = value
      //efetua a pesquisa
      this.filter = '{"$or":[{"codigo":{"$eq":"' + value + '"}},{"descricao":{"$like":"%25' + value + '%25"}}]}'
      this.loadData()
    },

    textST(value) {
      return getText(value, this.metadata.item.stitem)
    },

    async loadData() {
      let params = { filter: this.filter }

      if (this.offset) {
        params.offset = this.nextPage
      }

      this.$store.dispatch('loadItemList', params)
      this.offset = false

      this.$store.dispatch('loadFilial', {})

    },

    handleMore() {
      this.offset = true
      this.loadData()
    },

    async handleImprimirEtiqueta() {
      let sendData = {}
      sendData.item = this.produtosMarcados;
      sendData.layout = parseInt(this.etiquetaSelecionada)

      var metodo = 'post'

      var modulo = 'cg/item/etiqueta/'
      //
      // const data = await apiORDSpost(this.$store, modulo, sendData, metodo)
      // if (!data.dados) {
      //   return
      // }
      //

      // modulo = 'pdf'

      apiDownloadPDF(this, modulo, sendData, metodo, true);


    },
  },

  components: {
    BarList, ItemForm, AnexosForm
  },

  mounted() {
    this.scroll()
  },

  created() {
    const savedState = sessionStorage.getItem('fvProdutosState');
    if (savedState) {
      const state = JSON.parse(savedState);
      this.filter = state.filter;
      this.searchString = state.searchString;
      sessionStorage.removeItem('fvProdutosState');
    }
    this.loadData()
  },

  destroyed() {
    window.onscroll = null
  },

}

</script>

<template>
  <div>
    <div id="list" v-show="!showForm && !showFormControlePedidos">
      <bar-list :refresh-button="true" :new-button="possuiPermissao" :pdf-button="false" :xls-button="false"
        :gerar-etiqueta="this.gerarEtiqueta" single-entity="Produto" plural-entity="Produtos"
        :valueSearch="searchString"
        :moreActions="moreActionsBarList" @action="handleAction" @print="showModalImprimirEtiqueta" @search="search"
        @new="handleNew" @refresh="loadData" title-search="Pesquise pelo código ou pela descrição">
      </bar-list>

      <div v-if="gerarEtiqueta" class="nb-product-bulkbar">
        <div class="nb-product-select-all">
          <input-checkbox label="Selecionar todos" v-model="marcarTodosProdutos" :value-checked="true"
            :value-unchecked="false"></input-checkbox>
        </div>
        <span class="nb-product-selection-count">{{ produtosSelecionados }} selecionado(s)</span>
      </div>

      <div class="default-container nb-product-list">
        <alert v-if="!itemList.length" type="norecord"></alert>

        <article class="nb-product-card" :class="{ 'nb-product-card--selectable': gerarEtiqueta }"
          v-for="(item, index) in itemList" :key="item.coditem || index">
          <div class="nb-product-card-top">
            <div class="nb-product-identity">
              <div v-if="gerarEtiqueta" class="nb-product-select">
                <input-checkbox class="nb-product-checkbox" label="" v-model="item.isChecked" :value-checked="true"
                  :value-unchecked="false"></input-checkbox>
              </div>
              <button type="button" class="nb-product-image" :aria-label="'Gerenciar imagem de ' + item.descricao"
                title="Gerenciar imagem" @click="handleAnexosForm(item.coditem, item.descricao)">
                <img v-if="item.url" :src="item.url" alt="">
                <i v-else class="fa fa-camera" aria-hidden="true"></i>
                <span class="nb-product-image-edit"><i class="fa fa-pencil" aria-hidden="true"></i></span>
              </button>
              <div class="nb-product-title">
                <div class="nb-product-title-line">
                  <h2>{{ item.descricao }}</h2>
                  <span v-if="item.stitem == 'I'" class="nb-product-badge nb-product-badge--inactive">
                    {{ textST(item.stitem) }}
                  </span>
                </div>
                <div class="nb-product-code">Código <strong>{{ item.codigo || '—' }}</strong></div>
              </div>
            </div>

            <div class="nb-product-actions">
              <bar-grid :moreActions="[]" :options="{ barDefault: true, btnArchive: true, btnArchiveLabel: 'Estoque', btnEdit: possuiPermissao, btnEditLabel: 'Editar' }"
                @edit="handleEdit(item.coditem)" @archive="handleArchive(item.coditem)"></bar-grid>
            </div>
          </div>

          <div class="nb-product-details">
            <div class="nb-product-detail">
              <span class="nb-product-detail-label">NCM</span>
              <strong>{{ item.ncm || '—' }}</strong>
            </div>
            <div class="nb-product-detail">
              <span class="nb-product-detail-label">Estoque</span>
              <strong v-if="item.saldo_estoque !== null && item.saldo_estoque !== undefined && item.saldo_estoque !== ''">
                {{ item.saldo_estoque }}<small v-if="item.uni"> {{ item.uni }}</small>
              </strong>
              <strong v-else>—</strong>
            </div>
            <div v-if="item.bloqueio_loja" class="nb-product-detail nb-product-detail--store-block">
              <span class="nb-product-detail-label">Loja</span>
              <span class="nb-product-badge nb-product-badge--blocked" :title="'Bloqueio loja: ' + item.bloqueio_loja">
                <i class="fa fa-ban" aria-hidden="true"></i> {{ item.bloqueio_loja }}
              </span>
            </div>
          </div>
        </article>
        <!-- <div>
                    <a v-if="nextPage>0" style="cursor: pointer; color: #0091ea;" @click="handleMore()">Exibir mais</a>
                </div> -->
      </div>
    </div>
    <item-form v-if="showForm" :index="coditem" :crud="crud" @closeform="closeForm"></item-form>

    <div class="nb-modal-scrollable" v-if="showFormControlePedidos">
      <div class="container nb-modal-scrollable-container" style="max-width: 700px">
        <div id="mymodal" class="nb-modal-scrollable-body">
          <item-form :index="coditem" :crud="crud" @closeform="closeForm"></item-form>
        </div>
      </div>
    </div>
    <anexos-form v-if="showAnexosForm" :params="{ ref: 'item', chaveref: coditem, title: descricao, showform: true }"
      @closeform="closeForm"></anexos-form>

    <!-- MODAL IMPRIMIR ETIQUETA -->
    <div class="nb-modal-scrollable" v-if="modalEtiqueta">
      <div class="container nb-modal-scrollable-container nb-email-container">
        <div class="nb-modal-header">
          <h5>Imprimir Etiqueta</h5>
          <button type="button" class="close" @click="closeModalImprimirEtiqueta" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="nb-modal-scrollable-body">
          <div>
            <form-field type="select" label="Tipo de Etiqueta" col="4" v-model="etiquetaSelecionada"
              :select-options="listaEtiquetas"></form-field>
          </div>
          <hr />
          <div class="container mb-3">
            <div class="row">
              <div class="container mb-2">
                <span><strong>ITENS SELECIONADOS</strong></span>
              </div>
            </div>
            <table class="table table-sm table-borderless">
              <thead>
                <tr class="border-top border-bottom border-light">
                  <th scope="col">Codigo</th>
                  <th scope="col">Nome</th>
                  <th scope="col"></th>
                </tr>
              </thead>
              <tbody>
                <tr class="border-bottom border-light" v-for="produto in produtosMarcados" :key="produto.id">
                  <th scope="row">
                    <span>{{ produto.codigo }}</span>
                  </th>
                  <td>
                    <span>{{ produto.descricao }}</span>
                  </td>
                  <td class="float-right">
                    <button class="btn-outline-sm" @click="deleteItemImprimirEtiqueta(produto)">
                      <i class="fa fa-trash"></i> Excluir
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="nb-modal-scrollable-footer">
            <v-button ref="btnConfirm" label="Imprimir" title="" @click="handleImprimirEtiqueta()"></v-button>
            <v-button ref="btnClose" label="Cancelar" title="" @click="closeModalImprimirEtiqueta"></v-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.nb-product-bulkbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 9px 14px;
  margin-bottom: 10px;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 9px;
}

.nb-product-select-all {
  flex: 1;
  min-width: 0;
}

.nb-product-selection-count {
  color: #475569;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
}

.default-container.nb-product-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 0;
  background: transparent;
  border: 0;
  box-shadow: none;
}

.nb-product-card {
  padding: 14px 16px;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.04);
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.nb-product-card:hover {
  border-color: #cbd5e1;
  box-shadow: 0 4px 12px rgba(15, 23, 42, 0.06);
}

.nb-product-card-top,
.nb-product-identity,
.nb-product-actions {
  display: flex;
  align-items: center;
}

.nb-product-card-top {
  justify-content: space-between;
  gap: 16px;
}

.nb-product-identity {
  flex: 1;
  min-width: 0;
  gap: 11px;
}

.nb-product-select {
  flex: 0 0 24px;
  width: 24px;
}

.nb-product-image {
  position: relative;
  display: flex;
  flex: 0 0 48px;
  width: 48px;
  height: 48px;
  align-items: center;
  justify-content: center;
  padding: 4px;
  color: #64748b;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  cursor: pointer;
}

.nb-product-image:focus-visible {
  outline: 2px solid #004e94;
  outline-offset: 2px;
}

.nb-product-image > img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

.nb-product-image > .fa {
  font-size: 19px;
}

.nb-product-image-edit {
  position: absolute;
  right: -5px;
  bottom: -5px;
  display: flex;
  width: 18px;
  height: 18px;
  align-items: center;
  justify-content: center;
  color: #fff;
  background: #004e94;
  border: 2px solid #fff;
  border-radius: 50%;
  font-size: 8px;
}

.nb-product-title {
  flex: 1;
  min-width: 0;
}

.nb-product-title-line {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px 9px;
}

.nb-product-title-line h2 {
  min-width: 0;
  margin: 0;
  color: #0b1c30;
  font-size: 15px;
  font-weight: 700;
  line-height: 1.35;
  overflow-wrap: anywhere;
}

.nb-product-code {
  margin-top: 3px;
  color: #64748b;
  font-size: 12px;
}

.nb-product-code strong {
  color: #334155;
  font-weight: 600;
}

.nb-product-badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 7px;
  border: 1px solid transparent;
  border-radius: 5px;
  font-size: 10px;
  font-weight: 700;
  line-height: 1.2;
}

.nb-product-badge--inactive {
  color: #92400e;
  background: #fffbeb;
  border-color: #fde68a;
}

.nb-product-badge--blocked {
  color: #b91c1c;
  background: #fef2f2;
  border-color: #fecaca;
}

.nb-product-actions {
  flex: 0 0 auto;
}

.nb-product-details {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
  margin: 12px 0 0 59px;
  padding-top: 11px;
  border-top: 1px solid #f1f5f9;
}

.nb-product-card--selectable .nb-product-details {
  margin-left: 94px;
}

.nb-product-detail {
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 3px;
}

.nb-product-detail-label {
  color: #64748b;
  font-size: 11px;
}

.nb-product-detail > strong {
  color: #334155;
  font-size: 12px;
  font-weight: 600;
  overflow-wrap: anywhere;
}

.nb-product-detail > strong small {
  color: #64748b;
  font-size: 11px;
  font-weight: 500;
}

.nb-product-detail--store-block {
  align-items: flex-start;
}

@media (max-width: 767.98px) {
  .nb-product-card-top {
    align-items: flex-start;
    flex-direction: column;
  }

  .nb-product-actions {
    align-self: flex-end;
  }

  .nb-product-details {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    margin-left: 0;
  }

  .nb-product-card--selectable .nb-product-details {
    margin-left: 0;
  }

  .nb-product-detail--store-block {
    grid-column: 1 / -1;
  }
}

@media (max-width: 575.98px) {
  .nb-product-card {
    padding: 12px;
  }

  .nb-product-actions {
    align-self: flex-end;
  }

  .nb-product-bulkbar {
    padding: 8px 10px;
  }
}

.btn-outline-sm {
  background: #f6f6f6 !important;
  border: 1px solid #f6f6f6 !important;
  border-radius: 3px;
  padding: .25rem .85rem;
}
</style>



// WEBPACK FOOTER //
// src/forms/item-list.vue